// @ts-ignore
import flags from 'app/components/SVGS/flags'

export const USA_ISO = 'usa'
export const RU_ISO = 'ru'
export const GB_ISO = 'gb'
const UA_ISO = 'ua'
const ES_ISO = 'es'
const FR_ISO = 'fr'

const AU_ISO = 'au'
const BN_ISO = 'bn'
const CN_ISO = 'cn'
const FJ_ISO = 'fj'
const GU_ISO = 'gu'
const ID_ISO = 'id'
const JP_ISO = 'jp'
const KH_ISO = 'kh'
const LA_ISO = 'la'
const MY_ISO = 'my'
const MV_ISO = 'mv'
const MO_ISO = 'mo'
const MM_ISO = 'mm'
const NZ_ISO = 'nz'
const MNP_ISO = 'mnp'
const PG_ISO = 'pg'
const PH_ISO = 'ph'
const SG_ISO = 'sg'
const KR_ISO = 'kr'
const LK_ISO = 'lk'
const TW_ISO = 'tw'
const TH_ISO = 'th'
const VN_ISO = 'vn'
const ZA_ISO = 'za'
const SZ_ISO = 'sz'
const KE_ISO = 'ke'
const MZ_ISO = 'mz'
const MU_ISO = 'mu'
const NG_ISO = 'ng'
const GH_ISO = 'gh'
const EG_ISO = 'eg'
const MA_ISO = 'ma'
const SA_ISO = 'sa'
const AE_ISO = 'ae'
const LB_ISO = 'lb'
const PK_ISO = 'pk'
const DK_ISO = 'dk'
const SE_ISO = 'se'

export const USA_CODE = '+1'
const RU_CODE = '+7'
const UA_CODE = '+38'
const GB_CODE = '+44'
const ES_CODE = '+34'
const FR_CODE = '+33'
const AU_CODE = '+61'
const BN_CODE = '+673'
const KH_CODE = '+855'
const CN_CODE = '+86'
const FJ_CODE = '+679'
const GU_CODE = '+1'
const ID_CODE = '+62'
const JP_CODE = '+81'
const LA_CODE = '+856'
const MY_CODE = '+60'
const MV_CODE = '+960'
const MO_CODE = '+976'
const MM_CODE = '+95'
const NZ_CODE = '+64'
const MNP_CODE = '+1'
const PG_CODE = '+675'
const PH_CODE = '+63'
const SG_CODE = '+65'
const KR_CODE = '+82'
const LK_CODE = '+94'
const TW_CODE = '+886'
const TH_CODE = '+66'
const VN_CODE = '+84'
const ZA_CODE = '+27'
const SZ_CODE = '+268'
const KE_CODE = '+254'
const MZ_CODE = '+258'
const MU_CODE = '+230'
const NG_CODE = '+234'
const GH_CODE = '+233'
const EG_CODE = '+20'
const MA_CODE = '+212'
const SA_CODE = '+966'
const AE_CODE = '+971'
const LB_CODE = '+961'
const PK_CODE = '+92'
const DK_CODE = '+45'
const SE_CODE = '+46'

const countriesCodes: Array<{ iso: string; code: string }> = [
  { iso: GB_ISO, code: GB_CODE },
  { iso: UA_ISO, code: UA_CODE },
  { iso: RU_ISO, code: RU_CODE },
  { iso: ES_ISO, code: ES_CODE },
  { iso: FR_ISO, code: FR_CODE },
  { iso: AU_ISO, code: AU_CODE },
  { iso: BN_ISO, code: BN_CODE },
  { iso: KH_ISO, code: KH_CODE },
  { iso: CN_ISO, code: CN_CODE },
  { iso: FJ_ISO, code: FJ_CODE },
  { iso: GU_ISO, code: GU_CODE },
  { iso: ID_ISO, code: ID_CODE },
  { iso: JP_ISO, code: JP_CODE },
  { iso: LA_ISO, code: LA_CODE },
  { iso: MY_ISO, code: MY_CODE },
  { iso: MV_ISO, code: MV_CODE },
  { iso: MO_ISO, code: MO_CODE },
  { iso: MM_ISO, code: MM_CODE },
  { iso: NZ_ISO, code: NZ_CODE },
  { iso: MNP_ISO, code: MNP_CODE },
  { iso: PG_ISO, code: PG_CODE },
  { iso: PH_ISO, code: PH_CODE },
  { iso: SG_ISO, code: SG_CODE },
  { iso: KR_ISO, code: KR_CODE },
  { iso: LK_ISO, code: LK_CODE },
  { iso: TW_ISO, code: TW_CODE },
  { iso: TH_ISO, code: TH_CODE },
  { iso: VN_ISO, code: VN_CODE },
  { iso: USA_ISO, code: USA_CODE },
  { iso: ZA_ISO, code: ZA_CODE },
  { iso: SZ_ISO, code: SZ_CODE },
  { iso: KE_ISO, code: KE_CODE },
  { iso: MZ_ISO, code: MZ_CODE },
  { iso: MU_ISO, code: MU_CODE },
  { iso: NG_ISO, code: NG_CODE },
  { iso: GH_ISO, code: GH_CODE },
  { iso: EG_ISO, code: EG_CODE },
  { iso: MA_ISO, code: MA_CODE },
  { iso: SA_ISO, code: SA_CODE },
  { iso: AE_ISO, code: AE_CODE },
  { iso: LB_ISO, code: LB_CODE },
  { iso: PK_ISO, code: PK_CODE },
  { iso: DK_ISO, code: DK_CODE },
  { iso: SE_ISO, code: SE_CODE },
]

const prepareCountriesCodeConstants = (countriesCodes: any, property: any, value: any) => {
  return countriesCodes.reduce((acc: any, el: any) => {
    acc[el[property]] = el[value]
    return acc
  }, {})
}

export const CODE_ISO = prepareCountriesCodeConstants(countriesCodes, 'code', 'iso')

export const ISO_CODE = prepareCountriesCodeConstants(countriesCodes, 'iso', 'code')

export const ISOs = prepareCountriesCodeConstants(countriesCodes, 'iso', 'iso')

export const CODES = countriesCodes.map(el => el.code)

export const ISOsForOrganizationSettings = countriesCodes.reduce((acc: any, countryCode: any) => {
  acc[countryCode.iso] = false
  return acc
}, {})

export const ISO_FLAG = {
  [USA_ISO]: flags.usa,
  [UA_ISO]: flags.ua,
  [RU_ISO]: flags.ru,
  [ES_ISO]: flags.es,
  [FR_ISO]: flags.fr,
  [GB_ISO]: flags.gb,
  [AU_ISO]: flags.au,
  [BN_ISO]: flags.bn,
  [KH_ISO]: flags.kh,
  [CN_ISO]: flags.cn,
  [FJ_ISO]: flags.fj,
  [GU_ISO]: flags.gu,
  [ID_ISO]: flags.id,
  [JP_ISO]: flags.jp,
  [LA_ISO]: flags.la,
  [MY_ISO]: flags.my,
  [MV_ISO]: flags.mv,
  [MO_ISO]: flags.mo,
  [MM_ISO]: flags.mm,
  [NZ_ISO]: flags.nz,
  [MNP_ISO]: flags.mnp,
  [PG_ISO]: flags.pg,
  [PH_ISO]: flags.ph,
  [SG_ISO]: flags.sg,
  [KR_ISO]: flags.kr,
  [LK_ISO]: flags.lk,
  [TW_ISO]: flags.tw,
  [TH_ISO]: flags.th,
  [VN_ISO]: flags.vn,
  [NG_ISO]: flags.ng,
  [AE_ISO]: flags.ae,
  [EG_ISO]: flags.eg,
  [PK_ISO]: flags.pk,
  [GH_ISO]: flags.gh,
  [KE_ISO]: flags.ke,
  [LB_ISO]: flags.lb,
  [MA_ISO]: flags.ma,
  [MU_ISO]: flags.mu,
  [MZ_ISO]: flags.mz,
  [SA_ISO]: flags.sa,
  [SZ_ISO]: flags.sz,
  [ZA_ISO]: flags.za,
  [DK_ISO]: flags.dk,
  [SE_ISO]: flags.se,
}

export const formatByISO = {
  [GB_ISO]: { length: GB_CODE.length + 10, min: 10, max: 11, format: 'xxxxxxxxxxx', code: GB_CODE },
  [USA_ISO]: { length: USA_CODE.length + 10, min: 10, max: 10, format: '(xxx) xxx - xxxx', code: USA_CODE },
  [UA_ISO]: { length: UA_CODE.length + 10, min: 10, max: 10, format: '(xxx) xxx - xxxx', code: UA_CODE },
  [RU_ISO]: { length: RU_CODE.length + 10, min: 10, max: 10, format: 'xxxxxxxxxx', code: RU_CODE },
  [ES_ISO]: { length: ES_CODE.length + 8, min: 8, max: 9, format: 'xxxxxxxx', code: ES_CODE },
  [FR_ISO]: { length: FR_CODE.length + 9, min: 9, max: 9, format: 'xxxxxxxxx', code: FR_CODE },
  [AU_ISO]: { length: AU_CODE.length + 9, min: 9, max: 9, format: 'xxxxxxxxx', code: AU_CODE },
  [BN_ISO]: { length: BN_CODE.length + 7, min: 7, max: 7, format: 'xxxxxxx', code: BN_CODE },
  [KH_ISO]: { length: KH_CODE.length + 8, min: 8, max: 9, format: 'xxxxxxxxx', code: KH_CODE },
  [CN_ISO]: { length: CN_CODE.length + 10, min: 10, max: 11, format: 'xxxxxxxxxx', code: CN_CODE },
  [FJ_ISO]: { length: FJ_CODE.length + 7, min: 7, max: 7, format: 'xxxxxxx', code: FJ_CODE },
  [GU_ISO]: { length: GU_CODE.length + 10, min: 10, max: 10, format: 'xxxxxxxxxx', code: GU_CODE },
  [ID_ISO]: { length: ID_CODE.length + 10, min: 10, max: 10, format: 'xxxxxxxxxx', code: ID_CODE },
  [JP_ISO]: { length: JP_CODE.length + 9, min: 9, max: 10, format: 'xxxxxxxxxx', code: JP_CODE },
  [LA_ISO]: { length: LA_CODE.length + 8, min: 8, max: 9, format: 'xxxxxxxxx', code: LA_CODE },
  [MY_ISO]: { length: MY_CODE.length + 9, min: 9, max: 9, format: 'xxxxxxxxx', code: MY_CODE },
  [MV_ISO]: { length: MV_CODE.length + 7, min: 7, max: 7, format: 'xxxxxxx', code: MV_CODE },
  [MO_ISO]: { length: MO_CODE.length + 9, min: 9, max: 10, format: 'xxxxxxxxxx', code: MO_CODE },
  [MM_ISO]: { length: MM_CODE.length + 7, min: 7, max: 10, format: 'xxxxxxxxxx', code: MM_CODE },
  [NZ_ISO]: { length: NZ_CODE.length + 8, min: 8, max: 10, format: 'xxxxxxxxx', code: NZ_CODE },
  [MNP_ISO]: { length: MNP_CODE.length + 10, min: 10, max: 10, format: 'xxxxxxxxxx', code: MNP_CODE },
  [PG_ISO]: { length: PG_CODE.length + 8, min: 8, max: 8, format: 'xxxxxxxx', code: PG_CODE },
  [PH_ISO]: { length: PH_CODE.length + 8, min: 8, max: 10, format: 'xxxxxxxxxx', code: PH_CODE },
  [SG_ISO]: { length: SG_CODE.length + 8, min: 8, max: 8, format: 'xxxxxxxx', code: SG_CODE },
  [KR_ISO]: { length: KR_CODE.length + 10, min: 10, max: 10, format: 'xxxxxxxxxx', code: KR_CODE },
  [LK_ISO]: { length: LK_CODE.length + 9, min: 9, max: 9, format: 'xxxxxxxxx', code: LK_CODE },
  [TW_ISO]: { length: TW_CODE.length + 9, min: 9, max: 9, format: 'xxxxxxxxx', code: TW_CODE },
  [TH_ISO]: { length: TH_CODE.length + 8, min: 8, max: 8, format: 'xxxxxxxx', code: TH_CODE },
  [VN_ISO]: { length: VN_CODE.length + 10, min: 10, max: 10, format: 'xxxxxxxxxx', code: VN_CODE },
  [ZA_ISO]: { length: ZA_CODE.length + 9, min: 9, max: 9, format: 'xxxxxxxxx', code: ZA_CODE },
  [SZ_ISO]: { length: SZ_CODE.length + 8, min: 8, max: 8, format: 'xxxxxxxx', code: SZ_CODE },
  [KE_ISO]: { length: KE_CODE.length + 9, min: 9, max: 10, format: 'xxxxxxxxx', code: KE_CODE },
  [MZ_ISO]: { length: MZ_CODE.length + 8, min: 8, max: 8, format: 'xxxxxxxx', code: MZ_CODE },
  [MU_ISO]: { length: MU_CODE.length + 8, min: 8, max: 8, format: 'xxxxxxxx', code: MU_CODE },
  [NG_ISO]: { length: NG_CODE.length + 8, min: 8, max: 10, format: 'xxxxxxxx', code: NG_CODE },
  [GH_ISO]: { length: GH_CODE.length + 7, min: 7, max: 7, format: 'xxxxxxx', code: GH_CODE },
  [EG_ISO]: { length: EG_CODE.length + 9, min: 9, max: 11, format: 'xxxxxxxxx', code: EG_CODE },
  [MA_ISO]: { length: MA_CODE.length + 9, min: 9, max: 9, format: 'xxxxxxxxx', code: MA_CODE },
  [SA_ISO]: { length: SA_CODE.length + 8, min: 8, max: 9, format: 'xxxxxxxx', code: SA_CODE },
  [AE_ISO]: { length: AE_CODE.length + 8, min: 8, max: 9, format: 'xxxxxxxx', code: AE_CODE },
  [LB_ISO]: { length: LB_CODE.length + 7, min: 7, max: 8, format: 'xxxxxxx', code: LB_CODE },
  [PK_ISO]: { length: PK_CODE.length + 9, min: 9, max: 9, format: 'xxxxxxxxx', code: PK_CODE },
  [DK_ISO]: { length: DK_ISO.length + 8, min: 8, max: 8, format: 'xx xx xx xx', code: DK_CODE },
  [SE_ISO]: { length: SE_ISO.length + 9, min: 9, max: 10, format: 'xxx xxxxxxx', code: SE_CODE },
}

// Please look documentation regarding carrier responses
// https://github.com/prohabits/prohabits-ui/wiki/sms-retry
export const CARRIER_ERRORS = {
  INVALID_PHONE: 'invalid phone',
  OPTED_OUT: 'opted out',
  DEFAULT: 'default',
}
